import React, { useState } from 'react'
import FabricCanvas from './FabricCanvas'
import { SpriteGenerator } from './sprite-generator'

interface Sprite {
  id: string
  imageUrl: string
  position?: { x: number; y: number }
  scale?: number
}

export default function SpritesPage() {
  const [selectedSprite, setSelectedSprite] = useState<string | null>(null)
  const [sprites, setSprites] = useState<Sprite[]>([])

  const handleSpriteGenerated = (imageUrl: string) => {
    console.log('Sprite generated:', imageUrl)
    const newSprite: Sprite = {
      id: `sprite-${Date.now()}`,
      imageUrl: imageUrl,
      position: { x: 0, y: 0 },
      scale: 0.4
    }
    setSprites((prevSprites) => [...prevSprites, newSprite])
  }

  const handleSpriteClick = (spriteId: string) => {
    setSelectedSprite(spriteId)
    console.log('Sprite clicked:', spriteId)
  }

  return (
    <div className="min-h-screen p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Sprite Creator</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Sprite Generator Form */}
          <div>
            <SpriteGenerator onSpriteGenerated={handleSpriteGenerated} />
          </div>

          {/* Canvas */}
          <div>
            <FabricCanvas
              sprites={sprites}
              width={800}
              height={600}
              onSpriteClick={handleSpriteClick}
            />
            {selectedSprite && (
              <div className="mt-4 p-4 bg-white rounded-lg shadow">
                <p className="text-sm text-gray-600">Selected sprite: {selectedSprite}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
} 